import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FsDesktopNavComponent from './FsDesktopNav.styles.js';
import {SubNavTitle, GlobalSubNav} from './FsDesktopNav.styles.js';
import Hamburger from '../FsHamburger/FsHamburger.jsx';
import Link from '../../../shared/Link/Link';
import {Image, withSitecoreContext} from '@sitecore-jss/sitecore-jss-react';
import { isServer } from '@sitecore-jss/sitecore-jss/utils';
import FsMainNavCardLink from '../FsMainNavCardLink/FsMainNavCardLink.jsx';
import NavLink from '../../../NavLink/NavLink.jsx';
import Overlay from '../../../shared/Overlay/Overlay.jsx';
import Button from "../../../shared/Button/Button.jsx";

export const FsDesktopNav = ({
  headerContext = {},
  fields,
  sitecoreContext: { globalContent, route, site },
  search,
  setSearch,
  className,
  ...props
}) => {

  const links = globalContent?.navigation;
  const utilityLinks = globalContent?.utilityLinks;
  const logo = globalContent?.logo;
  const homePageLink = globalContent?.homepageLink;
  const languageSelector = globalContent?.languageSelectorItems;
  const ProductsText =
    Array.isArray(links) &&
    links.find(
      ({ type, cards }) =>
        type === 'megamenu-cards' && cards && cards.filter(({ type }) => type === 'product').length > 0
    )?.text;
  const [subNav, setSubNav] = useState(false);
  const [activeLink, setActiveLink] = useState('');
  const [isStaging, setIsStaging] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.location.hostname === 'fs.dsbeta.com') {
      setIsStaging(true);
    }
  }, []);
  return (
    <>
      <FsDesktopNavComponent search={search} className={`hide-on-print nav-${className}`}>
        <Hamburger aria-label="Menu toggle" className="hamburger" />
        <div className="logo hide-on-print">
          <Link href={homePageLink}>
            <Image field={logo} imageParams={{ mw: 200, mh: 200 }} />
          </Link>
        </div>
        <nav aria-label="Main Navigation" role="navigation" className="hide-on-print">
          {Array.isArray(utilityLinks) &&
            utilityLinks.map(({ title, path, href }, index) => {
              return (
                <NavLink
                  className="nav-end-link"
                  role="menuitem"
                  key={`${index}-${title}`}
                  text={title}
                  path={path}
                  href={href}
                />
              );
            })}
        </nav>
        <div
          aria-label="Dropdown Navigation"
          role="menu"
          id="nav-menu-dropdown"
          className="nav-end hide-on-print"
        >
          {Array.isArray(links) &&
            links.map(({ path, title, type, cards, text }, index) => {
              if (type && type === 'megamenu-cards') {
                if (cards && cards.length > 0) {
                  return (
                    <NavLink
                      key={`${index}-${title}`}
                      text={title}
                      subNav
                      cardCount={cards.length}
                      className="dropdown-button fsdb"
                      path={path}
                      aria-haspopup={type === 'megamenu-cards' ? 'true' : undefined}
                      active={activeLink === title ? 'true' : 'false'}
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        setActiveLink((prevActiveLink) =>
                          prevActiveLink === title ? null : title
                        );
                        setSubNav((prevSubNav) => (prevSubNav === title ? null : title));
                      }}
                    />
                  );
                }
              }
              return (
                <NavLink className="reg-link" key={`${index}-${title}`} text={title} path={path} />
              );
            })}
          <Button
            id="MainNavBtn"
            target="_blank"
            text="Contact a Rep"
            size="small"
            href="/contact"
            variant="yellowBlue"
          />
        </div>
        <GlobalSubNav active={subNav === 'insights' || subNav === 'Insights'}>
          <div className="inner">
            <SubNavTitle>
              <div className="subnav-title">Explore Bush&#39;s Beans Insights</div>
            </SubNavTitle>
            <div
              className={`card-list card-no-${
                (links || []).find((link) => link.text === 'insights')?.cards.length || 0
              }`}
            >
              {Array.isArray(links)
                ? links.map((link, linkIndex) => {
                    return link.text === 'insights'
                      ? link.cards.map(
                          ({ title, image: { src }, alt, link: { text, path } }, cardIndex) => {
                            return (
                              <FsMainNavCardLink
                                key={`${linkIndex}-${cardIndex}-${title}`}
                                text={title}
                                src={src}
                                alt={`view ${alt} page`}
                                path={path}
                                query={text}
                              />
                            );
                          }
                        )
                      : null;
                  })
                : null}
            </div>
          </div>
        </GlobalSubNav>
        <GlobalSubNav active={subNav === 'recipes' || subNav === 'Recipes'}>
          <div className="inner">
            <SubNavTitle>
              <div className="subnav-title">Explore Bush&#39;s Beans Recipes</div>
              <Button text="View All Recipes" href="/recipes" variant="yellowBrown" />
            </SubNavTitle>
            <div
              className={`card-list card-no-${
                (links || []).find((link) => link.text === 'recipes')?.cards.length || 0
              }`}
            >
              {Array.isArray(links)
                ? links.map((link, linkIndex) => {
                    return link.text === 'recipes'
                      ? link.cards.map(
                          ({ title, image: { src }, alt, link: { text, path } }, cardIndex) => {
                            return (
                              <FsMainNavCardLink
                                key={`${linkIndex}-${cardIndex}-${title}`}
                                text={title}
                                src={src}
                                alt={`view ${alt} page`}
                                path={path}
                                query={text}
                              />
                            );
                          }
                        )
                      : null;
                  })
                : null}
            </div>
          </div>
        </GlobalSubNav>
        <GlobalSubNav
          active={
            subNav === 'products' ||
            subNav === 'Products' ||
            subNav === 'productos' ||
            subNav === 'Productos'
          }
        >
          <div className="inner">
            <SubNavTitle>
              <div className="subnav-title">Explore Bush&#39;s Beans Products</div>
              <Button text="View All Products" href="/bulk-products" variant="yellowBrown" />
            </SubNavTitle>
            <div
              className={`card-list card-no-${
                (links || []).find((link) => link.text === 'products' || link.text === 'productos')
                  ?.cards.length || 0
              }`}
            >
              {Array.isArray(links)
                ? links.map((link, linkIndex) => {
                    return link.text === 'products' ||
                      link.text === 'productos' ||
                      link.text === 'Productos'
                      ? link.cards.map(
                          ({ title, image: { src }, alt, link: { text, path } }, cardIndex) => {
                            return (
                              <FsMainNavCardLink
                                key={`${linkIndex}-${cardIndex}-${title}`}
                                text={title}
                                src={src}
                                alt={`view ${alt} page`}
                                path={path}
                                query={text}
                              />
                            );
                          }
                        )
                      : null;
                  })
                : null}
            </div>
          </div>
        </GlobalSubNav>
      </FsDesktopNavComponent>
      {(subNav === 'products' ||
        subNav === 'Products' ||
        subNav === 'productos' ||
        subNav === 'Productos' ||
        subNav === 'insights' ||
        subNav === 'Insights' ||
        subNav === 'recipes' ||
        subNav === 'Recipes') && <Overlay id="overlay" onClick={() => setSubNav('')} />}
    </>
  );
};

FsDesktopNav.propTypes = {
  headerContext: PropTypes.object,
  fields: PropTypes.object,
  sitecoreContext: PropTypes.object,
  search: PropTypes.bool,
  setSearch: PropTypes.func,
  className: PropTypes.string,
};

export default withSitecoreContext()(FsDesktopNav);